import {Route, Routes} from "react-router-dom";
import routes from "../routes/routes.ts";
import {createElement} from "react";
import {ToastContainer} from "react-toastify";
import {useSelector} from "react-redux";
import {AppRootStateType} from "../state/store.ts";


export const DefaultLayout = () => {
    const isInitialized = useSelector<AppRootStateType, boolean>(state => state.app.isInitialized)

    return (
        <div className={`DefaultLayoutWrapper`}>
            {
                isInitialized
                    ? <Routes>
                        {
                            routes.map((route, idx) => {
                                return (
                                    route.element && (
                                        <Route
                                            index={route.index}
                                            key={idx}
                                            path={route.path}
                                            element={createElement(route.element)}
                                        />
                                    )
                                )
                            })
                        }
                    </Routes>
                    : ''
            }
            <ToastContainer className={'ToastContainer'} containerId={'main'}/>
        </div>
    )
}